import { render, staticRenderFns } from "./BarChannel.vue?vue&type=template&id=dd5c79ae&"
import script from "./BarChannel.vue?vue&type=script&lang=js&"
export * from "./BarChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports